import { CUSTOMERINFO_URLS, DASHBOARD_URLS } from "../../services/apiConfig.js";
import { ACSIDENTITY_ERRORS } from "../../common/constants/ivrModule/acsConstants.js";
import { KEYWORD_ERRORS } from "../../common/constants/dashboardModule/keywordConstants.js";
import apiClient from "../apiInstance.js";

export const getcustomerhistory = async ({customerguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_HISTORY, {
            customerguid
        });
        console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getcustomertexts = async ({customerguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_TEXTS, {
            customerguid
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getKeywordSearchInfo = async ({startDate, endDate, searchKeyword, searchType}) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_KEYWORD_SEARCH, {
            startDate,
            endDate,
            searchKeyword,
            searchType
        });
        return response.data;
    } catch (error) {
        console.error(KEYWORD_ERRORS.FETCH_KEYWORD_ERROR, error);
        throw error;
    }
};

export const getcustomercalls = async ({customerguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_CALLS, {
            customerguid
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

// paymentType is optional — pass "Payment", "Promise to Pay" or "Smart Link"
// to narrow to a single event kind, or omit it for all three.
export const getcustomerpayments = async ({customerguid, paymentType = null}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_PAYMENTS, {
            customerguid,
            paymentType
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getcustomerchats = async ({customerguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_CHATS, {
            customerguid
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getcustomeremails = async ({customerguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_EMAILS, {
            customerguid
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getcustomerdataset = async ({customerguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_DATASET, {
            customerguid
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const sendText = async ({to, message, customerguid, agentguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.SEND_TEXT_MESSAGE, {
            to, message, customerguid, agentguid
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const sendEmail = async ({emailaddress, message, subject, customerguid, agentguid }) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.SEND_EMAIL_MESSAGE, {
            emailaddress, message, subject, customerguid, agentguid 
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getConversationCompliance = async ({conversationID}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CONVERSATION_COMPLIANCE, {
            conversationID
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching conversation compliance', error);
        throw error;
    }
};

export const getconversationcomplianceForR413 = async ({conversationID}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CONVERSATION_COMPLIANCE_FORR413, {
            conversationID
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching conversation compliance', error);
        throw error;
    }
};

export const getcustomeroptin = async ({customerguid}) => {
    try {
        const response = await apiClient.post(CUSTOMERINFO_URLS.GET_CUSTOMER_OPT_IN, {
            customerguid
        });
        //console.log("getting this data:", response.data)
        return response.data;
    } catch (error) {
        throw error;
    }
};